<template>
  <div>
    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="text-subtitle-2">Movimento de Estoque</h3>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="movimento.id"
              dense
              label="Número"
              disabled
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <z-date-picker-menu
              v-model="movimento.data"
              dense
              label="Data"
              filled
              readonly
            ></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              v-model="movimento.movimento"
              dense
              label="Movimento"
              filled
              :items="['Entrada', 'Saída']"
              readonly
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="movimento.fornecedor_id"
              dense
              label="Fornecedor"
              filled
              readonly
              :items="$store.getters['listas/fornecedores']"
            ></v-autocomplete>
          </v-col>
          
          <v-col sm="2">
            <z-campo-valor
              label="Valor Total"
              v-model="movimento.valor_total"
              readonly
              filled
              dense
              hide-details
            ></z-campo-valor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="text-subtitle-2">Contas a Pagar</h3>
      </v-toolbar>
      
      <v-divider></v-divider>
      
      <template v-if="!movimento.contaspagar_count">
      <!-- <template > -->
        <v-toolbar flat color="white" dense>
          <v-btn depressed color="primary" @click="lancarContasPagar" :disabled="!podeLancar" class="mr-2">Lançar Conta a Pagar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            depressed 
            :disabled="contaspagar.length == 0 || salvando"
            @click="limparContasPagar" 
          >Limpar</v-btn>
          <v-btn v-if="movimento.id" depressed color="primary" class="mr-2" :disabled="contaspagar.length == 0" @click="salvar" :loading="salvando">Salvar</v-btn>
        </v-toolbar>
        <v-divider></v-divider>
      </template>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="contaspagar"
          hide-default-footer
          disable-sort
        >
          <template #item.parcela="{ item, index }">
            <span>{{ index + 1 }}</span>
          </template>

          <template #item.vencimento="{ item }">
            <z-date-picker-menu
              v-model="item.vencimento"
              :value="item.vencimento"
              single-line
              hide-details
              filled
              outlined
              dense
              raise-on-focus
              :readonly="!!item.movimento_id"
            ></z-date-picker-menu>
          </template>

          <template #item.valor="{ item }">
            <span>{{ item.valor | valorBR }}</span>
          </template>

          <!-- <template #item.opcoes="{ item }">
            <v-btn icon @click="contaspagar.splice(contaspagar.indexOf(item), 1)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template> -->
        </v-data-table>
      </v-card-text>
    </v-card>

    <dialogo-lancar-contas-pagar 
      ref="dialogoLancarContasPagar"
      :saldo="saldo"
      @onGerarParcelas="gerarParcelas"
    ></dialogo-lancar-contas-pagar>
  </div>
</template>

<script setup>

import DialogoLancarContasPagar from './DialogoLancarContasPagar.vue';

import { ref, computed, mounted, getCurrentInstance, inject } from 'vue';
import { useContasPagarStore } from '@/app/store/pinia/contaspagar';

const contasPagarStore = useContasPagarStore();

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $router = proxy.$router;
const $route = proxy.$route;
const $dayjs = proxy.$dayjs;
const $notificacao = inject('notificacao');
const salvando = ref(false);
const dialogoLancarContasPagar = ref(null);

const headers = [
  { text: 'Parcela', value: 'parcela', width: '100px' },
  { text: 'Vencimento', value: 'vencimento', width: '200px' },
  { text: 'Forma Pagamento', value: 'forma_pagamento' },
  { text: 'Valor', value: 'valor', width: '150px' },
  // { text: 'Opções', value: 'opcoes', width: '100px' }
];

// const contaspagar = ref([]);

const movimento = computed(() => {
  return $store.state.movimentoestoque.movimento;
});

const contaspagar = computed(() => {
  return $store.state.movimentoestoque.movimento.contaspagar || [];
});

const totalParcelas = computed(() => {
  return contaspagar.value.reduce((total, item) => total + parseFloat(item.valor), 0).toFixed(2);
});

const podeLancar = computed(() => {
  return totalParcelas.value < movimento.value.valor_total;
});

const saldo = computed(() => {
  return Number (movimento.value.valor_total - totalParcelas.value).toFixed(2);
});


function lancarContasPagar() {
  console.log('Lançar contas a pagar');
  dialogoLancarContasPagar.value.abrir();
}

function gerarParcelas(lancamento) {
  console.log('Gerar parcelas:', lancamento);
  $store.state.movimentoestoque.movimento.contaspagar = [];

  const parcelas = dividirEmParcelas(saldo.value, lancamento.parcelas);
  const parcelas_existentes = contaspagar.value.length;
  // console.log('Parcelas geradas:', parcelas, 'Total existente:', parcelas_existentes);

  console.log("Parcelas:", parcelas, "Parcelas existentes:", parcelas_existentes);

  parcelas.forEach((valor, index) => {
    const dataVencimento = $dayjs(lancamento.vencimento).add(index, 'month');
    let dataFinal = dataVencimento;

    // Verifica se é fim de semana e ajusta
    const diaSemana = dataVencimento.day(); // 0 = domingo, 6 = sábado
    if (diaSemana === 6) { // sábado
      dataFinal = dataVencimento.add(2, 'day');
    } else if (diaSemana === 0) { // domingo
      dataFinal = dataVencimento.add(1, 'day');
    }

    const dataVencimentoFormatted = dataFinal.format('YYYY-MM-DD');

    let documento = null;

    if (movimento.value.id) {
      documento = `${movimento.value.id}-${index + parcelas_existentes + 1}`;
    }

    contaspagar.value.push({
      documento: documento,
      vencimento: dataVencimentoFormatted,
      forma_pagamento: lancamento.forma_pagamento,
      valor: valor
    });
  });

  console.log('Contas a pagar após gerar parcelas:', contaspagar.value);

}


function dividirEmParcelas(valorTotal, numeroParcelas) {
  const parcelas = [];

  const valorBase = parseFloat((valorTotal / numeroParcelas).toFixed(2));

  for (let i = 0; i < numeroParcelas; i++) {
    parcelas.push(valorBase);
  }

  const somaParcelas = parcelas.reduce((acc, val) => acc + val, 0);
  const diferenca = parseFloat((valorTotal - somaParcelas).toFixed(2));

  parcelas[0] = parseFloat((parcelas[0] + diferenca).toFixed(2));

  return parcelas;
}

function limparContasPagar() {
  $store.state.movimentoestoque.movimento.contaspagar = [];
}

async function salvar() {

  try {
    salvando.value = true;
    if (contaspagar.value.length === 0) {
      $notificacao.error('Não há contas a pagar para salvar.');
      return;
    }

    await contasPagarStore.salvarContaPagarFromEstoque(contaspagar.value, movimento.value.id);
    $notificacao.notificar('Contas a pagar salvas com sucesso!');
    $router.push({ name: "EstoqueLista" });
  } catch (error) {
    $notificacao.error('Erro ao salvar contas a pagar.', error);
  } finally {
    salvando.value = false;
  }

}

defineExpose({
  gerarParcelas
})

</script>

<style lang="scss" scoped>

</style>